/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertDecisionRuleCommand } from './InternalApiAlertDecisionRuleCommand';
import {
    InternalApiAlertDecisionRuleCommandFromJSON,
    InternalApiAlertDecisionRuleCommandFromJSONTyped,
    InternalApiAlertDecisionRuleCommandToJSON,
    InternalApiAlertDecisionRuleCommandToJSONTyped,
} from './InternalApiAlertDecisionRuleCommand';

/**
 * 
 * @export
 * @interface InternalApiCreateAlertDecisionRulesCommandRule
 */
export interface InternalApiCreateAlertDecisionRulesCommandRule {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCreateAlertDecisionRulesCommandRule
     */
    sortOrder: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateAlertDecisionRulesCommandRule
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiCreateAlertDecisionRulesCommandRule
     */
    runOnlyOnFinal: boolean;
    /**
     * 
     * @type {InternalApiAlertDecisionRuleCommand}
     * @memberof InternalApiCreateAlertDecisionRulesCommandRule
     */
    runCommand: InternalApiAlertDecisionRuleCommand;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiCreateAlertDecisionRulesCommandRule
     */
    values: Array<string>;
}



/**
 * Check if a given object implements the InternalApiCreateAlertDecisionRulesCommandRule interface.
 */
export function instanceOfInternalApiCreateAlertDecisionRulesCommandRule(value: object): value is InternalApiCreateAlertDecisionRulesCommandRule {
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('runOnlyOnFinal' in value) || value['runOnlyOnFinal'] === undefined) return false;
    if (!('runCommand' in value) || value['runCommand'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function InternalApiCreateAlertDecisionRulesCommandRuleFromJSON(json: any): InternalApiCreateAlertDecisionRulesCommandRule {
    return InternalApiCreateAlertDecisionRulesCommandRuleFromJSONTyped(json, false);
}

export function InternalApiCreateAlertDecisionRulesCommandRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateAlertDecisionRulesCommandRule {
    if (json == null) {
        return json;
    }
    return {
        
        'sortOrder': json['sortOrder'],
        'name': json['name'],
        'runOnlyOnFinal': json['runOnlyOnFinal'],
        'runCommand': InternalApiAlertDecisionRuleCommandFromJSON(json['runCommand']),
        'values': json['values'],
    };
}

export function InternalApiCreateAlertDecisionRulesCommandRuleToJSON(json: any): InternalApiCreateAlertDecisionRulesCommandRule {
    return InternalApiCreateAlertDecisionRulesCommandRuleToJSONTyped(json, false);
}

export function InternalApiCreateAlertDecisionRulesCommandRuleToJSONTyped(value?: InternalApiCreateAlertDecisionRulesCommandRule | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sortOrder': value['sortOrder'],
        'name': value['name'],
        'runOnlyOnFinal': value['runOnlyOnFinal'],
        'runCommand': InternalApiAlertDecisionRuleCommandToJSON(value['runCommand']),
        'values': value['values'],
    };
}

